import React from "react";
import { Box, Skeleton } from "@mui/material";
import Card from "./Card";

export const TableCardSkeleton = ({ title, subtitle }) => (
  <Card
    header={{
      hardTitle: <Skeleton width={200} />,
    }}
    style={{
      minHeight: "auto",
      padding: "12px 16px",
    }}
  >
    <Box sx={{ position: "relative", width: "100%" }}>
      <Skeleton width={300} sx={{ mb: 2 }} />

      <Skeleton
        variant="rectangular"
        width="100%"
        height={365}
        sx={{
          borderRadius: 1,
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        }}
      />
    </Box>
  </Card>
);
